module.exports = __webpack_public_path__ + "img/1f7ce78b037b5b168db8e6935063f8ca.094bf775.png";